import { PlusOutlined, SaveOutlined, TableOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, DatePickerProps, Divider, Form, InputNumber, Radio, Row, Select, Space, Table, Tag } from "antd";
import { ContentHeader } from "../../components";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Links } from "../../helpers/Links";
import { Link, useNavigate } from "react-router-dom";
import { menuHelper } from "../../helpers/account";
import { KyTinhThueKhongThuongXuyenResponse } from '../../models/thue/Thue';
import { formatVND, validateMessages } from '../../helpers/common';
import dayjs, { Dayjs } from 'dayjs';
import { layDanhSachKyThueKhongThuongXuyen, layDsThueThangTheoNam } from '../../services/thue';
import { layDsThuLaoKCTTheoNam } from '../../services/thulaokhongchuyentrach';
import { layDsPhuCapTGVTheoNam } from '../../services/luong';
import { layDsKhenThuongNhanSuKhac } from '../../services/nhansukhac';
import { layThongTinCauHinhThue } from '../../services/setting';
import ModalTextForm from '../../components/modal/ModalTextForm';

const DanhSachThueThangKhongThuongXuyen = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<Array<KyTinhThueKhongThuongXuyenResponse>>();
    const menu: any = menuHelper.checkMultiPermission([Links.Thue.DsThueKhongThuongXuyen, Links.Thue.ChiTietThueKhongThuongXuyen]);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(dayjs());
    let thangHienTai = (dayjs()).startOf('month').format('DD/MM/YYYY HH:mm:ss');

    const [form] = Form.useForm();
    const [openModalKhoiTao, setOpenModalKhoiTao] = useState<boolean>(false);
    const [dsKhongThuThueModal, setDsKhongThuThueModal] = useState<number[]>([]);
    const [loaiChuKyModal, setLoaiChuKyModal] = useState<number>(1);

    // States cho từng thành phần
    const [dsLuongThuLaoKCT, setDsLuongThuLaoKCT] = useState<Array<any>>([]);
    const [dsLuongPhuCapTGV, setDsLuongPhuCapTGV] = useState<Array<any>>([]);
    const [dsKhenThuongNSK, setDsKhenThuongNSK] = useState<Array<any>>([]);
    const [dsThueTamTinh, setDsThueTamTinh] = useState<Array<any>>([]);

    // State namLoc cho từng thành phần
    const [namLocThuLaoKCT, setNamLocThuLaoKCT] = useState<Dayjs | null>(null);
    const [namLocPhuCapTGV, setNamLocPhuCapTGV] = useState<Dayjs | null>(null);
    const [namLocKhenThuongNSK, setNamLocKhenThuongNSK] = useState<Dayjs | null>(null);
    const [namLocThueTamTinh, setNamLocThueTamTinh] = useState<Dayjs | null>(null);

    const layDuLieu = async (date: string) => {
        try {
            setIsLoading(true);
            var rs = await layDanhSachKyThueKhongThuongXuyen(date);
            setDataTable((rs || []).map((v: KyTinhThueKhongThuongXuyenResponse) => { return { ...v, key: v.id } }));
            setIsLoading(false);
        }
        catch (err: any) {
            toast.error(err);
            setIsLoading(false);
        }
    }

    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            layDuLieu(dateStr);
        } else {
            layDuLieu("");
        }
    }

    // Hàm lấy ds từng thành phần theo năm
    const layDsThanhPhanTheoNam = async (nam?: number) => {
        try {
            const [tlkct, pctgv, ktnsk, thueTamTinh] = await Promise.all([
                layDsThuLaoKCTTheoNam(nam),
                layDsPhuCapTGVTheoNam(nam),
                layDsKhenThuongNhanSuKhac(""),
                layDsThueThangTheoNam(nam),
            ]);
            setDsLuongThuLaoKCT(tlkct ?? []);
            setDsLuongPhuCapTGV(pctgv ?? []);
            setDsKhenThuongNSK(ktnsk ?? []);
            setDsThueTamTinh(thueTamTinh ?? []);
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    const handleOpenModalKhoiTao = async () => {
        const ky = dayjs();
        const namKy = dayjs().year(ky.year());
        setNamLocThuLaoKCT(namKy);
        setNamLocPhuCapTGV(namKy);
        setNamLocKhenThuongNSK(namKy);
        setNamLocThueTamTinh(namKy);
        setDsKhongThuThueModal([]);
        setLoaiChuKyModal(1);

        let mucToiThieu = 2000000;
        try {
            const cauHinh = await layThongTinCauHinhThue();
            if (cauHinh?.soTienToiThieuTinhThueKTX !== undefined && cauHinh?.soTienToiThieuTinhThueKTX >= 0) {
                mucToiThieu = cauHinh.soTienToiThieuTinhThueKTX;
            }
        } catch (e) {
            console.error(e);
        }

        form.setFieldsValue({
            loaiChuKy: 1,
            thoiGian: ky,
            quy: 1,
            nam: namKy,
            mucToiThieu: mucToiThieu,
            dsIdThuLaoKCT: [],
            dsIdPhuCapTGV: [],
            dsIdKhenThuongNSK: [],
            dsIdThueTamTinh: [],
        });
        await layDsThanhPhanTheoNam(ky.year());
        setOpenModalKhoiTao(true);
    };

    const taoOnChangeNamLoc = (
        setNamLoc: (d: Dayjs | null) => void,
        fieldName: string,
        setListFn: React.Dispatch<React.SetStateAction<any[]>>,
        fetchFn: (nam?: number) => Promise<any[]>,
        filterFn?: (item: any) => boolean
    ) => async (date: Dayjs | null) => {
        setNamLoc(date);
        try {
            const rawData = await fetchFn(date ? date.year() : undefined);
            const filteredData = filterFn ? (rawData ?? []).filter(filterFn) : (rawData ?? []);
            const currentSelected = form.getFieldValue(fieldName);
            const selectedIds: number[] = Array.isArray(currentSelected)
                ? currentSelected
                : (currentSelected != null ? [currentSelected] : []);
            const selectedSet = new Set(selectedIds);

            setListFn(prevList => {
                const map = new Map<number, any>();
                filteredData.forEach(item => {
                    if (item && item.id != null) map.set(item.id, item);
                });
                (prevList ?? []).forEach(item => {
                    if (item && item.id != null && selectedSet.has(item.id) && !map.has(item.id)) {
                        map.set(item.id, item);
                    }
                });
                return Array.from(map.values());
            });
        } catch (err: any) {
            toast.error(err?.toString().replace('Error: ', ''));
        }
    };

    const onFinishKhoiTao = async (values: any) => {
        try {
            const loaiChuKy = values.loaiChuKy || 1;
            let thangNam = '';
            let quy = 0;
            let nam = dayjs().year();

            if (loaiChuKy === 1) {
                const date = values.thoiGian as Dayjs;
                thangNam = date.format('MM/YYYY');
                nam = date.year();
            } else {
                quy = values.quy || 1;
                nam = values.nam ? (values.nam as Dayjs).year() : dayjs().year();
                thangNam = `Quý ${quy}/${nam}`;
            }

            const mucToiThieu = values.mucToiThieu !== undefined && values.mucToiThieu !== null ? values.mucToiThieu : 2000000;

            const chiTietTinhThue = {
                dsKhenThuong: (values?.dsIdKhenThuongNSK ?? []) as number[],
                dsThuLaoKCT: (values?.dsIdThuLaoKCT ?? []) as number[],
                dsThuLaoTGV: (values?.dsIdPhuCapTGV ?? []) as number[],
                dsThueThanhPhan: (values?.dsIdThueTamTinh ?? []) as number[],
                dsKhongThuThue: dsKhongThuThueModal,
                mucToiThieu: mucToiThieu,
            };

            setOpenModalKhoiTao(false);
            navigate(Links.Thue.ChiTietThueKhongThuongXuyen, {
                state: {
                    loaiChuKy,
                    quy,
                    nam,
                    thoiGian: thangNam,
                    mucToiThieu,
                    chiTietTinhThue
                }
            });
        } catch (err: any) {
            toast.error(err?.toString().replace("Error: ", ""));
        }
    };

    // Helper render 1 row chọn thành phần (năm lọc + select multiple + cờ tạm thu 10% nếu có người đạt mức tối thiểu)
    const renderThanhPhanRow = (
        label: string,
        fieldName: string,
        namLoc: Dayjs | null,
        onChangeNam: (d: Dayjs | null) => void,
        options: { value: number; label: string }[],
        rawList?: Array<any>
    ) => {
        const selectedIds: number[] = form.getFieldValue(fieldName) || [];
        const itemsWithMucToiThieu = (rawList || []).filter(item => selectedIds.includes(item.id) && item.coNguoiDatMucToiThieu);

        return (
            <div style={{ marginBottom: 12 }}>
                <Row gutter={8}>
                    <Col span={8}>
                        <Form.Item label={`Năm ${label}`} style={{ marginBottom: 0 }}>
                            <DatePicker
                                changeOnBlur={true}
                                picker="year"
                                placeholder="Năm (để trống = tất cả)"
                                style={{ width: "100%" }}
                                value={namLoc}
                                onChange={onChangeNam}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={16}>
                        <Form.Item label={label} name={fieldName} style={{ marginBottom: 0 }}>
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder={`Chọn ${label.toLowerCase()}`}
                                options={options}
                                notFoundContent="Không có dữ liệu"
                                onChange={() => {
                                    setDsKhongThuThueModal(prev => [...prev]);
                                }}
                                filterOption={(input, option: any) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>
                    </Col>
                </Row>
                {itemsWithMucToiThieu.length > 0 && (
                    <Row gutter={8} style={{ marginTop: 6, paddingLeft: 8 }}>
                        <Col span={24}>
                            <Space wrap direction="horizontal">
                                {itemsWithMucToiThieu.map(item => {
                                    const isKhongThu = dsKhongThuThueModal.includes(item.id);
                                    return (
                                        <Checkbox
                                            key={`khongthu_${item.id}`}
                                            checked={!isKhongThu}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setDsKhongThuThueModal(dsKhongThuThueModal.filter(x => x !== item.id));
                                                } else {
                                                    setDsKhongThuThueModal([...dsKhongThuThueModal, item.id]);
                                                }
                                            }}
                                        >
                                            <span style={{ fontSize: '13px' }}>
                                                Tạm thu 10% thuế cho: <b style={{ color: '#1890ff' }}>{item.ten}</b>
                                            </span>
                                        </Checkbox>
                                    );
                                })}
                            </Space>
                        </Col>
                    </Row>
                )}
            </div>
        );
    };

    const optionsThuLaoKCT = dsLuongThuLaoKCT.map(x => ({ value: x.id, label: x.ten }));
    const optionsPhuCapTGV = dsLuongPhuCapTGV.map(x => ({ value: x.id, label: x.ten }));
    const optionsKhenThuongNSK = dsKhenThuongNSK.map(x => ({ value: x.id, label: x.ten }));
    const optionsThueTamTinh = dsThueTamTinh.map(x => ({ value: x.id, label: x.tenKyThue }));

    useEffect(() => {
        layDuLieu(thangHienTai);
    }, []);

    return (
        <section>
            <ContentHeader title="Thuế TNCN không thường xuyên" />
            <Row className="mb-2">
                <Col span="6">
                    <DatePicker changeOnBlur={true} value={ngayThang} style={{ width: "100%" }} placeholder="Tháng tính thuế" picker="month" format={thangNamFormat} onChange={onChange} />
                </Col>
                <Col span="18">
                    <Space className="float-right">
                        <Link to={Links.Thue.TongHopThue}>
                            <Button type="default" icon={<TableOutlined />}>Tổng hợp Thuế</Button>
                        </Link>
                        {
                            menu[Links.Thue.ChiTietThueKhongThuongXuyen] &&
                            <Button className="hrm-btn hrm-btn-warning" onClick={handleOpenModalKhoiTao}>
                                <PlusOutlined rev="" />Thêm mới
                            </Button>
                        }
                    </Space>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Tháng" dataIndex="kyThue" key="kyThue" />
                            <Column title="Số CBCNV" dataIndex="soNhanVien" key="soNhanVien" />                            
                            <Column title="Tổng tiền thuế phải nộp" dataIndex="tongThuePhaiNop" key="tongThuePhaiNop" render={(text: number) => formatVND(text)} />
                            <Column title="Trạng thái" dataIndex="khoaDieuChinh" key="khoaDieuChinh" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="success">Mở khóa</Tag>); break;
                                    case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
                                }
                                return tag;
                            }} />
                            {
                                menu[Links.Thue.ChiTietThueKhongThuongXuyen] &&
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Thue.ChiTietThueKhongThuongXuyen + "?id=" + record.id}>Xem</Link>
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>

            {openModalKhoiTao && (
                <ModalTextForm
                    title="Khởi tạo bảng tính thuế không thường xuyên"
                    hideFooter
                    show={openModalKhoiTao}
                    handleClose={() => setOpenModalKhoiTao(false)}
                >
                    <Form layout="vertical" validateMessages={validateMessages} onFinish={onFinishKhoiTao} form={form}>
                        <Row gutter={12}>
                            <Col span={24}>
                                <Form.Item label="Loại chu kỳ" name="loaiChuKy" initialValue={1}>
                                    <Radio.Group onChange={(e) => setLoaiChuKyModal(e.target.value)}>
                                        <Radio value={1}>Theo Tháng</Radio>
                                        <Radio value={2}>Theo Quý</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>

                        {loaiChuKyModal === 1 ? (
                            <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item label="Thời gian (Tháng/Năm)" name="thoiGian" rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}>
                                        <DatePicker
                                            changeOnBlur={true}
                                            style={{ width: "100%" }}
                                            placeholder="Chọn thời gian"
                                            picker="month"
                                            format={["MM/YYYY", "MMYYYY"]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Mức thu nhập tối thiểu tính thuế" name="mucToiThieu" rules={[{ required: true, message: 'Vui lòng nhập mức tối thiểu' }]}>
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            min={0}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value ? Number(value.replace(/\$\s?|(,*)/g, '')) : 0}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        ) : (
                            <Row gutter={12}>
                                <Col span={8}>
                                    <Form.Item label="Quý" name="quy" rules={[{ required: true, message: 'Vui lòng chọn quý' }]} initialValue={1}>
                                        <Select
                                            options={[
                                                { value: 1, label: 'Quý 1' },
                                                { value: 2, label: 'Quý 2' },
                                                { value: 3, label: 'Quý 3' },
                                                { value: 4, label: 'Quý 4' },
                                            ]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Năm" name="nam" rules={[{ required: true, message: 'Vui lòng chọn năm' }]}>
                                        <DatePicker
                                            changeOnBlur={true}
                                            style={{ width: "100%" }}
                                            placeholder="Chọn năm"
                                            picker="year"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Mức tối thiểu tính thuế" name="mucToiThieu" rules={[{ required: true, message: 'Vui lòng nhập mức tối thiểu' }]}>
                                        <InputNumber
                                            style={{ width: "100%" }}
                                            min={0}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value ? Number(value.replace(/\$\s?|(,*)/g, '')) : 0}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#1890ff', fontSize: '16px', fontWeight: 'bold' }}>
                                Thu nhập chịu thuế
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Phụ cấp tổ giúp việc", "dsIdPhuCapTGV", namLocPhuCapTGV,
                            taoOnChangeNamLoc(setNamLocPhuCapTGV, "dsIdPhuCapTGV", setDsLuongPhuCapTGV, layDsPhuCapTGVTheoNam),
                            optionsPhuCapTGV, dsLuongPhuCapTGV)}

                        {renderThanhPhanRow("Thù lao không chuyên trách", "dsIdThuLaoKCT", namLocThuLaoKCT,
                            taoOnChangeNamLoc(setNamLocThuLaoKCT, "dsIdThuLaoKCT", setDsLuongThuLaoKCT, layDsThuLaoKCTTheoNam),
                            optionsThuLaoKCT, dsLuongThuLaoKCT)}

                        {renderThanhPhanRow("Khen thưởng nhân sự khác", "dsIdKhenThuongNSK", namLocKhenThuongNSK,
                            taoOnChangeNamLoc(setNamLocKhenThuongNSK, "dsIdKhenThuongNSK", setDsKhenThuongNSK, () => layDsKhenThuongNhanSuKhac("")),
                            optionsKhenThuongNSK, dsKhenThuongNSK)}

                        <Divider orientation="left" style={{ margin: '16px 0 12px 0' }}>
                            <span style={{ color: '#722ed1', fontSize: '16px', fontWeight: 'bold' }}>
                                Các khoản thuế thành phần
                            </span>
                        </Divider>

                        {renderThanhPhanRow("Thuế đã tạm tính/tạm thu", "dsIdThueTamTinh", namLocThueTamTinh,
                            taoOnChangeNamLoc(setNamLocThueTamTinh, "dsIdThueTamTinh", setDsThueTamTinh, layDsThueThangTheoNam),
                            optionsThueTamTinh)}

                        <Form.Item style={{ marginTop: 16 }}>
                            <Button type="primary" loading={isLoading} className="float-right" htmlType="submit" icon={<SaveOutlined />}>
                                Khởi tạo & Tính thuế
                            </Button>
                        </Form.Item>
                    </Form>
                </ModalTextForm>
            )}
        </section>
    );
};

export default DanhSachThueThangKhongThuongXuyen;